import React from 'react';
import { Button } from '../../Button';

const HomeButton = () => {
  const handleOnPress = () => {
    window.location.replace('/');
  };

  return (
    <Button classButton="back" onPress={handleOnPress}>
      Back to main page
    </Button>
  );
};

export default HomeButton;
